import { useMutation, useQueryClient } from "@tanstack/react-query";
import { switchDelegation } from "../../api/delegation";
import { SwitchDelegationModel } from "../../interfaces/delegation";
import { invalidateDelegationQueries } from "./delegationQueryKeys";

export const useSwitchDelegation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (model: SwitchDelegationModel) => switchDelegation(model),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["userInfo"] });
      invalidateDelegationQueries(queryClient);
      window.location.href = "/";
    },
  });
};
